export enum SignupType {
  oneTap = 'one-tap',
  googleOneTap = 'google-one-tap',
  sso = 'sso',
  googleSso = 'google-sso',
  direct = 'direct',
  facebookSso = 'facebook-sso',
  flab = 'flab-abs',
  flabSso = 'flab-sso',
}

export type GoogleOneTapCredential = {
  idToken: string;
};

export type GoogleOneTapError = {
  type?: string;
  message?: string;
};

export type SignupTypeValue = typeof SignupType[keyof typeof SignupType];

export type SSOStartUrlParamsContextType = {
  /*
    The url to redirect the user to when the account is connected. Backend defaults
    to `settings.SSO_DEFAULT_REDIRECT_URL` (/app/dashboard)
  */
  next?: string;

  /*
    Whether the backend needs to create an Authentication model for the user. This
    is best utilizied in conjunction with `scopes_selected_api`.
  */
  build_auths?: boolean;

  /*
    The selected API that we'll use lookup scopes to include when building the
    Authentication record for the user.
  */
  scopes_selected_api?: string;

  /*
    In some scenarios we delay triggering the new users onboarding to ensure
    data is in the correct state when we decide which flow to send them.
  */
  should_delay_email_onboarding?: boolean;
};

export type GoogleYOLO = {
  setRenderMode: (renderMode: 'bottomSheet' | 'navPopout') => void;
};
